import React from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import globals from '../globals'
import SubNavigation from '../modules/SubNavigation'
import DataSource from '../DataSource'
import { SERVICE_SPEED_BOOST } from '../constants'
import AjaxLoader from '../components/AjaxLoader'
import ServiceHeading from '../modules/ServiceHeading'
import SpeedBoostStatus from '../modules/SpeedBoostStatus'
import SpeedBoostModule from '../modules/SpeedBoostModule'
import ThingsToKnow from '../modules/ThingsToKnow'
import SpeedBoostHistory from '../modules/SpeedBoostHistory'
import Error from '../components/Error'

class SpeedBoostService extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
		    isLoaded: false,
            hasErrors: false,
            serviceId: parseInt(this.props.match.params.id),
            serviceDetails: {}
        }

        this.type = SERVICE_SPEED_BOOST
    }

    componentDidMount () {
        DataSource.getData(`/api/getService/speedBoost/${this.state.serviceId}`, result => {
            this.setState({
                serviceDetails: result,
                isLoaded: true
            })
            globals.animatePageIn(this.container)
        }, () => {
            this.setState({ isLoaded: true, hasErrors: true })
        })
    }

    getSubNav () {
	    return [
            { title: 'Activate Boost', url: '' },
            { title: 'My Speed Boost Status', url: '/status' },
            { title: 'My Speed Boost History', url: '/history' },
            { title: 'Terms & Conditions', url: '/terms' }
        ]
    }

    updateServiceDetails (data) {
	    this.setState({
            serviceDetails: { ...this.state.serviceDetails, ...data }
        })
    }

    render () {
        const RenderBoostMeNow = () => {
            return <SpeedBoostModule serviceDetails={this.state.serviceDetails} serviceId={this.state.serviceId} updateServiceDetails={this.updateServiceDetails.bind(this)} />
        }

	    const RenderBoostStatus = () => {
            return <SpeedBoostStatus serviceDetails={this.state.serviceDetails} isLoaded={this.state.isLoaded} />
        }

	    const RenderHistory = () => {
            return <SpeedBoostHistory serviceDetails={this.state.serviceDetails} serviceId={this.state.serviceId} />
        }

	    const RenderTerms = () => {
            if (this.state.serviceDetails.businessBoost) {
                return <ThingsToKnow type='speedBoostSmb' />
            } else {
                return <ThingsToKnow type='speedBoost' />
            }

        }

        if (!this.state.isLoaded) {
            return <AjaxLoader />
        }

        if (this.state.hasErrors) {
            return <Redirect push to='/' />
        }

        return (
            <div ref={el => this.container = el} style={{ opacity: 0 }}>
                <ServiceHeading
                    type={this.type}
                    icon={`/images/${this.state.serviceDetails.boostStatus === 'Active' ? 'On.svg' : 'Off.svg'}`}
                    smallText={this.state.serviceDetails.address}
                    medText='Push button. Boost speed'
                >
                    <div className='col-lg-6 d-flex justify-content-end learn-more-sb'>
                        <a href='https://www.exetel.com.au/speed-boost' target='_blank'>
                            <img className='d-none d-lg-block' src='/images/find-out-more.svg' alt='find-out-more' />
                            <span className='d-block d-lg-none underline color-indigo font-small'>Learn more</span>
                        </a>
                    </div>
                </ServiceHeading>

                <SubNavigation
                    title='Manage my service'
                    items={this.getSubNav()}
                    url={this.props.match.url}
                    className='gtm-service-manage-tab-click flex-basis-25'
                    mobileSubCopy='(click the arrow on the right to enable your boost, check history and boost status) '
                />

                <Switch>
                    <Route exact path={`${this.props.match.url}`} component={RenderBoostMeNow} />
                    <Route exact path={`${this.props.match.url}/status`} render={RenderBoostStatus} />
                    <Route exact path={`${this.props.match.url}/history`} render={RenderHistory} />
                    <Route exact path={`${this.props.match.url}/terms`} render={RenderTerms} />
                </Switch>
            </div>
        )
    }
}

export default withRouter(SpeedBoostService)



// WEBPACK FOOTER //
// ./resources/js/services/SpeedBoostService.js